var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-application v-application--is-ltr theme--light",staticStyle:{"background-color":"inherit","display":"block"},attrs:{"data-app":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }